import { createAllInOneHttpClient } from '../../core/infra/createAllInOneHttpClient'
import { PendingTendersRepository } from '../infra/PendingTendersRepository'

export type RejectTenderParams = {
  tenderUuid: string
  rejectReason?: string
}

type RejectTenderFactoryDependencies = {
  pendingTendersRepository: PendingTendersRepository
}

export function rejectTenderFactory({ pendingTendersRepository }: RejectTenderFactoryDependencies) {
  return async function rejectTenderImpl(
    params: RejectTenderParams,
    config?: { signal?: AbortSignal }
  ) {
    return pendingTendersRepository.rejectTender({
      tenderUuid: params.tenderUuid,
      rejectReason: params.rejectReason,
      config,
    })
  }
}

export function rejectTender(params: RejectTenderParams, config?: { signal?: AbortSignal }) {
  const httpClient = createAllInOneHttpClient()
  const pendingTendersRepository = new PendingTendersRepository({ httpClient })
  const rejectTenderImpl = rejectTenderFactory({ pendingTendersRepository })
  return rejectTenderImpl(params, config)
}
